<template>
  <v-container class="SecurityParameter">
    <v-sheet
      min-height="300"
      rounded="lg"
      elevation="6"
    >
    <Toolbar
      :handle-reset="resetForm"
      :handle-submit="onSendForm"
      >
        <template slot="left">
          <v-toolbar-title v-if="item" class="hidden-md-and-down toolbartitle_50"  >
            <h1><v-icon large>mdi-account-cog</v-icon>{{ $t('administration.securityparameter.securityparameter')}}</h1>
          </v-toolbar-title>
        </template>
    </Toolbar>
    <SecurityParameterForm
      ref="updateForm"
      v-if="item"
      :values="item"
      :errors="violations"
    />
    <v-row>
      <v-col md="12">
        <v-divider></v-divider>
        <p class="ml-4">{{ $t('administration.securityparameter.' + item['name'] ) }}</p>
      </v-col>
    </v-row>
    <Loading :visible="isLoading || deleteLoading" />
  </v-sheet>
  </v-container>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import { mapFields } from 'vuex-map-fields';
import SecurityParameterForm from '../../components/securityparameter/Form.vue';
import Loading from '../../components/Loading';
import Toolbar from '../../components/Toolbar';
import UpdateMixin from '../../mixins/UpdateMixin';

const servicePrefix = 'SecurityParameter';

export default {
  name: 'SecurityParameterUpdate',
  servicePrefix,
  mixins: [UpdateMixin],
  components: {
    Loading,
    Toolbar,
    SecurityParameterForm
  },

  computed: {
    ...mapFields('securityparameter', {
      deleteLoading: 'isLoading',
      isLoading: 'isLoading',
      error: 'error',
      updated: 'updated',
      violations: 'violations'
    }),
    ...mapGetters('securityparameter', ['find'])

  },

  methods: {
    ...mapActions('securityparameter', {
      deleteItem: 'del',
      retrieve: 'load',
      update: 'update',
    })
  }
};
</script>
